import React, { FC } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { PurchaseRequestEquipmentLineItemRowDisplay } from '../purchase_request_equipment_line_item_row_display/PurchaseRequestEquipmentLineItemRowDisplay';
import ViaStockLocationDisplay from '../equipment_per_stock_location_row_display/ViaStockLocationDisplay';

const DEFAULT_BACK_LINK_TEXT = 'Back to purchase order';

const EquipmentPOLineItemWithViaSLDisplay: FC<any> = ({ lineItem }): React.ReactElement => {
	return (
		<div className="flex flex-col">
			<PurchaseRequestEquipmentLineItemRowDisplay purchaseRequestEquipmentLineItem={lineItem} />
			<ViaStockLocationDisplay
				viaStockLocation={nullSafeGet('viaStockLocation', lineItem)}
				backLinkText={DEFAULT_BACK_LINK_TEXT}
			/>
		</div>
	);
};

export default EquipmentPOLineItemWithViaSLDisplay;
